module.exports = __webpack_public_path__ + "static/media/app-hotel.bc7cf58b.png";